import { ApiProperty } from '../../codegen';
import {
  IsBoolean,
  IsDate,
  IsEnum,
  IsNotEmpty,
  IsOptional,
  IsString,
} from '../../validators';

import {
  EWithdrawalKycProvider,
  EWithdrawalKycStatus,
} from './withdrawal-kyc.enums';

export class CreateWithdrawalKycSessionDto {
  @ApiProperty()
  @IsString({ groups: ['error'] })
  @IsNotEmpty({ groups: ['error'] })
  returnUrl: string;
}

export class WithdrawalKycStatusDto {
  @ApiProperty()
  @IsEnum(EWithdrawalKycStatus, { groups: ['error'] })
  status: EWithdrawalKycStatus;

  @ApiProperty()
  @IsEnum(EWithdrawalKycProvider, { groups: ['error'] })
  provider: EWithdrawalKycProvider;

  @ApiProperty()
  @IsDate({ groups: ['error'] })
  updatedAt: Date;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsDate({ groups: ['error'] })
  approvedAt?: Date | null;

  @ApiProperty()
  @IsBoolean({ groups: ['error'] })
  canStart: boolean;

  @ApiProperty()
  @IsBoolean({ groups: ['error'] })
  canContinue: boolean;
}

export class WithdrawalKycSessionDto {
  @ApiProperty()
  @IsEnum(EWithdrawalKycStatus, { groups: ['error'] })
  status: EWithdrawalKycStatus;

  @ApiProperty()
  @IsEnum(EWithdrawalKycProvider, { groups: ['error'] })
  provider: EWithdrawalKycProvider;

  @ApiProperty()
  @IsString({ groups: ['error'] })
  verificationUrl: string;
}
